export const TEST_ID = 'createBatteryForm';
